; (function ($, _) {
    var common = require('../common');

    // 总页数
    var pageNum = 0;
    var displayPage = 10;
    // 默认参数
    var opts = {
        offset: 0,
        length: 10,
        total: 0,
        $container: $('.page'),
        $pageWrapper: $('[data-role="page-wrapper"]'),
        $prevBtn: $('.btn_pre'),
        $nextBtn: $('.btn_next')
    };

    /**
     * 分页
     * @class Pagination
     * @constructor
     */
    var Pagination = {
        /**
         * 模块初始化
         * @method init
         */
        init: function (options) {
            this.initUI(options);
            this.eventBinding();
        },

        /**
         * 界面初始化
         * @method initUI
         */
        initUI: function (options) {
            var html = '';
            opts = _.extend(opts, options);
            pageNum = Math.ceil(opts.total / opts.length);
            if (pageNum > 1) {
                opts.$container.show();
                for (var i = 1; i < Math.min(pageNum + 1, displayPage + 1); i++) {
                    html += ' <a href="javascript:;" data-offset="' + (i - 1) + '">' + i + '</a> ';
                }
                opts.$pageWrapper.html(html);
            }
            opts.$pageWrapper
                .attr('cur-page', 0)
                .find('> a:eq(0)')
                .addClass('cur');
            opts.$prevBtn.addClass('btn_dis');
        },

        /**
         * 事件绑定
         * @method eventBinding
         */
        eventBinding: function () {
            opts.$pageWrapper.off('click')
                .on('click', '> a', Pagination.switchPage);
            opts.$prevBtn.off('click')
                .on('click', Pagination.prevPage);
            opts.$nextBtn.off('click')
                .on('click', Pagination.nextPage);
        },

        curPageRender: function (offset) {
            if (offset > Math.ceil(displayPage / 2) - 1) {
                var html = '';
                var start;
                var end = offset + displayPage - Math.ceil(displayPage / 2);
                if (end > pageNum) {
                    end = pageNum;
                    start = Math.max(pageNum - displayPage + 1, 1);
                } else {
                    start = Math.max(offset - Math.ceil(displayPage / 2) + 1, 1);
                }
                opts.$pageWrapper.empty();
                for (var i = start; i < Math.min(end + 1, pageNum + 1); i++) {
                    html += ' <a href="javascript:;" data-offset="' + (i - 1) + '">' + i + '</a> ';
                }
                opts.$pageWrapper.html(html);
            } else if (opts.$pageWrapper.find('> a:eq(0)').data('offset') != 0) {
                var html = '';
                opts.$pageWrapper.empty();
                for (var i = 1; i < Math.min(displayPage + 1, pageNum + 1); i++) {
                    html += ' <a href="javascript:;" data-offset="' + (i - 1) + '">' + i + '</a> ';
                }
                opts.$pageWrapper.html(html);
            }
            opts.$pageWrapper
                .attr('cur-page', offset)
                .find('> a')
                .removeClass('cur')
                .filter('[data-offset="' + offset + '"]')
                .addClass('cur');
            if (offset <= 0) {
                opts.$prevBtn.addClass('btn_dis');
                opts.$nextBtn.removeClass('btn_dis');
            } else if (offset >= pageNum - 1) {
                opts.$prevBtn.removeClass('btn_dis');
                opts.$nextBtn.addClass('btn_dis');
            } else {
                opts.$prevBtn.removeClass('btn_dis');
                opts.$nextBtn.removeClass('btn_dis');
            }
        },

        prevPage: function (e) {
            var $this = $(e.target).closest('a');
            var curPage = opts.$pageWrapper.attr('cur-page');
            var offset = parseInt(curPage) - 1;
            if (offset < 0) {
                return false;
            }

            Pagination.pageRender(offset, function () {
                Pagination.curPageRender(offset);
            });
            return false;
        },

        nextPage: function (e) {
            var $this = $(e.target).closest('a');
            var curPage = opts.$pageWrapper.attr('cur-page');
            var offset = parseInt(curPage, 10) + 1;
            if (offset > pageNum - 1) {
                return false;
            }

            Pagination.pageRender(offset, function () {
                Pagination.curPageRender(offset);
            });
            return false;
        },

        switchPage: function (e) {
            var $this = $(e.target).closest('a');
            var curPage = parseInt(opts.$pageWrapper.attr('cur-page'), 10);
            var offset = parseInt($this.text(), 10) - 1;
            if (offset == curPage) {
                return false;
            }

            Pagination.pageRender(offset, function () {
                Pagination.curPageRender(offset);
            });
            return false;
        },

        pageRender: $.noop,

        setPageRender: function (func) {
            this.pageRender = func;
        }
    };

    if (typeof exports === 'object') {
        module.exports = Pagination;
    }
})(jQuery, _);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/pagination.js
// module id = 64
// module chunks = 7 10 11